"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snackbar_1 = require("src/Snackbar");
var Telemetry_1 = require("src/Telemetry");
var formatGraphqlError_1 = require("./formatGraphqlError");
var MessageDisplayContext = React.createContext(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return console.error(args);
});
exports.MessageDisplayConsumer = MessageDisplayContext.Consumer;
exports.MessageDisplayProvider = MessageDisplayContext.Provider;
exports.withDisplayMessage = function (ComponentClass) { return function (props) { return (React.createElement(exports.MessageDisplayConsumer, null, function (displayMessage) {
    var fullProps = Object.assign({}, props, { displayMessage: displayMessage });
    return (React.createElement(ComponentClass, __assign({}, fullProps)));
})); }; };
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.eventMessageCount = 0;
        _this.didRecieveMessage = function (message, type) {
            if (type === 'error') {
                Telemetry_1.Sentry.logError(new Error(message));
            }
            _this.eventMessageCount++;
            _this.setState({ eventMessage: message, eventMessageType: type });
            _this.forceUpdate();
        };
        _this.state = {};
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { renderError: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        Telemetry_1.Sentry.logError(error);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.renderError) {
            // You can render any custom fallback UI
            return (React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: formatGraphqlError_1.default(this.state.renderError.message) }));
        }
        return (React.createElement(React.Fragment, null,
            this.state.eventMessage && (React.createElement(Snackbar_1.CustomSnackbar, { variant: this.state.eventMessageType || 'error', message: formatGraphqlError_1.default(this.state.eventMessage), key: this.eventMessageCount })),
            React.createElement(exports.MessageDisplayProvider, { value: this.didRecieveMessage }, this.props.children)));
    };
    return ErrorBoundary;
}(React.Component));
exports.ErrorBoundary = ErrorBoundary;
